import { Epic } from 'redux-observable';
import {
  filter, map, mergeMap, takeUntil,
} from 'rxjs/operators';
import eventSettingEditActions from 'admin-data/event/EventEdit/redux/eventSettingEditActions';
import { concat, defer, of } from 'rxjs';
import eventSettingEditSelectors from 'admin-data/event/EventEdit/redux/eventSettingEditSelectors';
import { Lobby } from 'admin-data/event/EventEdit/redux/eventSettingEditState';
import eventEditSelectors from 'admin-data/event/EventEdit/redux/eventEditSelectors';
import { EVENT_FIRESTORE_API } from 'config';

const fetchEventSettingLobbyEpic: Epic = (action$, state$) => action$.pipe(
  filter(eventSettingEditActions.fetchLobbyPage.match),
  mergeMap(() => {
    const { event: { domain } } = eventEditSelectors.selectEventEdit(state$.value);
    const getEventUrl = `${EVENT_FIRESTORE_API}?event_domain=${domain}`;
    const fetchLobbyPage = defer(() => fetch(getEventUrl));
    return concat(
      of(eventSettingEditActions.internalUpdateLoadingLobby(true)),
      fetchLobbyPage.pipe(
        mergeMap((resp) => resp.json() as Promise<{ lobby: Lobby }>),
        map((haha) => {
          const { lobby } = haha;
          const currentLobbyPage = eventSettingEditSelectors.selectEventLobbyPage(state$.value);
          return eventSettingEditActions.internalUpdateLobbyPage({ ...currentLobbyPage, ...lobby });
        }),
      ),
      of(eventSettingEditActions.internalUpdateLoadingLobby(false)),
    ).pipe(
      takeUntil(action$.pipe(filter(eventSettingEditActions.fetchLobbyPage.match))), // fetch until another fetch started
    );
  }),
);

export default fetchEventSettingLobbyEpic;
